import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";
import { AHText, Circle } from "arkh";
import { useFragment, useSubscription } from "react-relay";
import { graphql } from "relay-runtime";
import { useMemo } from "react";
import { TeamHeaderAssignedBadge_storeViewer$key } from "./__generated__/TeamHeaderAssignedBadge_storeViewer.graphql";

export function TeamHeaderAssignedBadge(props: {
  storeViewer: TeamHeaderAssignedBadge_storeViewer$key;
}) {
  const { currentEmployeeId } = usePersistedEmployeeId();

  const storeViewer = useFragment(
    graphql`
      fragment TeamHeaderAssignedBadge_storeViewer on StoreViewer {
        assignedCount
      }
    `,
    props.storeViewer
  );

  useSubscription(
    useMemo(
      () => ({
        variables: {
          employeeId: currentEmployeeId,
        },
        subscription: graphql`
          subscription TeamHeaderAssignedBadgeSubscription($employeeId: ID) {
            storeViewerAssignedCountChanged(employeeId: $employeeId) {
              id
              assignedCount
            }
          }
        `,
      }),
      [currentEmployeeId]
    )
  );

  if (storeViewer.assignedCount === 0) {
    return null;
  }

  return (
    <Circle
      size="small"
      color="text-primary"
      style={{
        position: "absolute",
        top: -5,
        left: -5,
      }}
    >
      <AHText type="info-small" color="text-inverted">
        {storeViewer.assignedCount}
      </AHText>
    </Circle>
  );
}
